const CONFIG_KEYS = {

  clientId: `${process.env.REACT_APP_CLIENTID}` as string,
  authority: `${process.env.REACT_APP_AUTHORITY}` as string,
  redirectUri: `${process.env.REACT_APP_REDIRECTURI}` as string, 

  ApplicationTitle:`${process.env.REACT_APP_APPLICATION_TITLE}` as string,
  ApplicationShortName:`${process.env.REACT_APP_APPLICATION_SHORT_NAME}` as string,
  ApplicationEnvironment: `${process.env.REACT_APP_APPLICATION_ENVIRONMENT_NAME}` as string,
  Version:`${process.env.REACT_APP_VERSION}` as string,

  baseUrl: `${process.env.REACT_APP_BASEURL}` as string,
  sseUrl:  `${process.env.REACT_APP_SSE_URL}`  as string,
  timeout: `${process.env.REACT_APP_TIMEOUT}`,
  retryCount: `${process.env.REACT_APP_RETRY_COUNT}`,
  retryDelay: `${process.env.REACT_APP_RETRY_DELAY}`,

  zoomClientID: `${process.env.ZOOM_Client_ID}`,

  fileSize_imageMaxSizeMB: `${process.env.REACT_APP_FILE_SIZE_IMAGE_MAX_SIZE_MB}` as unknown as number,
  fileSize_videoMaxSizeMB: `${process.env.REACT_APP_FILE_SIZE_VIDEO_MAX_SIZE_MB}`  as unknown as number,
  fileSize_DocumentMaxSizeMB:`${process.env.REACT_APP_FILE_SIZE_DOCUMENT_MAX_SIZE_MB}` as unknown as number,

  tutorSubCost: `${process.env.REACT_APP_Tutor_SubCost}` as unknown as number,
  tutorSubCostCurrency: `${process.env.REACT_APP_Tutor_SubCost_Currency}` as string,

  // Client ID only — this is public by design (it identifies the PayPal app, not a secret).
  // The Client Secret must never be referenced from frontend code.
  paypalClientId: `${process.env.REACT_APP_PAYPAL_CLIENT_ID}` as string,
  paypalEnv: `${process.env.REACT_APP_PAYPAL_ENV}` as "sandbox" | "live",

  googleClientId: `${process.env.REACT_APP_GOOGLE_CLIENT_ID}` as string,

};
export default CONFIG_KEYS;
